import { HugeIcon } from '@/components/icons/HugeIcon';
import { CV_PRESET_ICONS } from '@/components/icons/icon-contracts';
import { GulfFlagIcon } from '@/components/icons/UaeFlagIcon';
import type { CvPresetIconKey } from './cv-presets';

/**
 * Web twin of `CvPresetIcon`. Same artwork contract as
 * `SkillCatalogIcon.web.tsx`: an inline-flex slot instead of a native View so
 * the glyph sits on the text baseline inside the sheet rows.
 */
export function CvPresetIcon({
  icon,
  size = 30,
}: {
  icon: CvPresetIconKey;
  size?: number;
}) {
  return (
    <span
      style={{
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {icon === 'flag-uae' ? (
        <GulfFlagIcon region="uae" size={Math.round(size * 0.58)} />
      ) : (
        <HugeIcon
          icon={CV_PRESET_ICONS[icon]}
          size={Math.round(size * 0.62)}
          color="var(--text-secondary)"
          strokeWidth={1.75}
        />
      )}
    </span>
  );
}
